'use client'

import {
  Message as MessageType,
  MessagePhotoModel,
} from '@marketplace-web/messaging/conversation-messaging-data'

import PhotoMessage from '../../../../PhotoMessage'

type Props = {
  message: MessageType
  isLast: boolean
  isReadByOppositeUser: boolean
  isCurrentAuthor: boolean
  createdTime: string
  onThumbnailClick?: (photoId: number) => void
}

const PhotoMessages = ({
  createdTime,
  isCurrentAuthor,
  isLast,
  isReadByOppositeUser,
  message,
  onThumbnailClick,
}: Props) => {
  return (
    <>
      {message.photos.map((photo: MessagePhotoModel, index: number) => {
        const isLastAndRead = isLast && isReadByOppositeUser && index + 1 === message.photos.length

        return (
          <PhotoMessage
            key={index}
            photo={photo}
            isCurrentAuthor={isCurrentAuthor}
            isLastAndRead={isLastAndRead}
            isLast={isLast}
            showTime={index === 0}
            createdTime={createdTime}
            messageId={message.id}
            onThumbnailClick={
              onThumbnailClick
                ? event => {
                    event.preventDefault()

                    onThumbnailClick(photo.id)
                  }
                : undefined
            }
          />
        )
      })}
    </>
  )
}

export default PhotoMessages
